import React, { useState, useEffect, ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import LoadingOverlay from 'components/common/LoadingOverlay';
import { VideoCtvRedux } from 'store-types';
import { authStartup, initializeParamountPlusUser } from 'actions/auth';

import useInterval from 'hooks/interval';

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const providers = useSelector((state: VideoCtvRedux) => state.kitchenSink.data.providers);
  const contentError = useSelector((state: VideoCtvRedux) => state.kitchenSink.error);

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      await dispatch(authStartup());
      setInitialized(true);
    };

    if (!initialized && providers) {
      initializeAuth();
    }
  }, [providers, dispatch, initialized]);

  const expiresIn = useSelector(
    (state: VideoCtvRedux) => state.auth?.paramountPlus?.token?.expiresIn,
  );
  useInterval(() => {
    if (expiresIn) {
      dispatch(initializeParamountPlusUser());
    }
  }, expiresIn);

  if (!initialized) {
    return contentError ? null : <LoadingOverlay />;
  }

  return <>{children}</>;
};

export default AuthProvider;
